<template>
    <div>
        <page-title>应用授权</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/app-order/edit">
                            <el-button type="text" @click="showCreateDialog = true">手动添加</el-button>
                        </router-link>
                    </div>
                    <div flex>
                        <div style="margin-right: 8px">
                            <el-date-picker
                                size="mini"
                                @change="dateChange"
                                v-model="date"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="app_id"
                                       clearable size="mini"
                                       placeholder="应用" @change="search()">
                                <el-option v-for="item in searchData.apps" :key="item.id" :label="item.display_name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="is_pay"
                                       clearable size="mini"
                                       placeholder="状态" @change="search()">
                                <el-option v-for="item in isPayOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-input v-model="keyword"
                                      @keyup.enter.native="search()"
                                      size="mini"
                                      placeholder="应用/站点名称/域名"
                                      suffix-icon="el-icon-search"/>
                        </div>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="host" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.host.name}}</div>
                        <div>{{scope.row.host.domain}}</div>
                        <div v-if="scope.row.log && scope.row.log.user && scope.row.log.user.name">授权人:{{scope.row.log.user.name}}</div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                    </template>
                </el-table-column>
                <el-table-column prop="app.display_name" label="应用名称"></el-table-column>
                <el-table-column label="插件">
                    <template slot-scope="scope">
                        <template v-if="scope.row.pluginOrdersCount">
                            <router-link :to="'/dashboard/admin/plugin-order/index?host_id=' + scope.row.host_id + '&app_id=' + scope.row.app_id   ">
                                {{scope.row.pluginOrdersCount.value}}
                            </router-link>
                        </template>
                        <template v-else>0</template>
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单">
                    <template slot-scope="scope">
                        <div>{{scope.row.order_no}}</div>
                        <div>
                            <el-button type="text" @click="updatePayPrice(scope.row)">￥{{scope.row.pay_price}}<i
                                    class="el-icon-edit"></i></el-button>
                            <span style="text-decoration: line-through;font-size: 12px;margin-left: 5px;color: #999">{{scope.row.price}}</span>
                        </div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                        <div style="font-size: 12px;color: #999">{{scope.row.add_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_forever === 1">
                            <div style="color: #909399; font-size: 12px;">无限制</div>
                        </template>
                        <template v-else>
                            <el-tooltip class="item" content="添加时间" placement="left">
                                <div style="color: #909399; font-size: 12px;">{{scope.row.begin_time}}</div>
                            </el-tooltip>
                            <el-tooltip class="item" content="更新时间" placement="left">
                                <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                            </el-tooltip>
                            <el-tooltip class="item" content="到期时间" placement="left">
                              <div style="color: #909399; font-size: 12px;">{{scope.row.end_time}}</div>
                            </el-tooltip>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="is_pay" label="状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.is_pay === 0">未支付</span>
                        <span style="color: #67C23A" v-else-if="scope.row.is_pay === 1">已授权</span>
                    </template>
                </el-table-column>
              <el-table-column prop="add_time" label="有效期">
                <template slot-scope="scope">
                  <template v-if="scope.row.is_forever === 1">
                    <div style="color: #909399; font-size: 12px;">无限制</div>
                  </template>
                  <template v-else>
                    <el-tooltip class="item" content="开始时间" placement="left">
                      <div style="color: #909399; font-size: 12px;">{{scope.row.begin_time}}</div>
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.update_time" class="item" content="更新时间" placement="left">
                      <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                    </el-tooltip>
                    <el-tooltip class="item" content="到期时间" placement="left">
                      <div style="color: #909399; font-size: 12px;">{{scope.row.end_time}}</div>
                    </el-tooltip>
                  </template>
                </template>
              </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <el-button type="text" v-if="scope.row.is_pay === 0" @click="updateIsPay(scope.row, 1)">
                                授权通过
                            </el-button>
                            <el-button type="text" v-else @click="updateIsPay(scope.row, 0)">取消授权</el-button>
                            <template v-if="scope.row.is_pay === 1">
                                <span class="text-split">|</span>
                                <router-link :to="'/dashboard/admin/app-renew/edit?id=' + scope.row.id">续费</router-link>
                            </template>
                            <span class="text-split">|</span>
                            <router-link :to="'/dashboard/admin/app-order/edit?id=' + scope.row.id">编辑</router-link>
                        </template>
                        <template v-if="scope.row.appRenew.length > 0">
                            <span class="text-split">|</span>
                            <router-link :to="'/dashboard/admin/app-renew/index?host_id=' + scope.row.host_id + '&app_id=' + scope.row.app_id">续费记录</router-link>
                        </template>
                        <template v-if="scope.row.is_delete === 0">
                            <span class="text-split">|</span>
                        </template>
                        <el-button type="text" v-if="scope.row.is_delete === 0"
                                   @click="updateIsDelete(scope.row,1)">删除
                        </el-button>
                        <el-button type="text" v-else @click="updateIsDelete(scope.row, 0)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    components: {
        'ViewCertificate': () => import('@/components/ViewCertificate.vue')
    },
    data() {
        return {
            showCreateDialog: false,
            loading: false,
            list: null,
            pagination: null,
            is_pay: null,
            host_id: null,
            app_id: null,
            keyword: '',
            isPayOptions: [
                {
                    label: '未支付',
                    value: 0
                },
                {
                    label: '已授权',
                    value: 1
                }
            ],
            searchData: {
                hostsLoading: false,
                hosts: [],
                pluginsLoading: false,
                plugins: [],
                apps: []
            },
            submitLoading: false,
            form: {
                host_id: null,
                app_id: null,
                is_pay: null
            },
            rules: {
                host_id: [
                    {required: true}
                ],
                app_id: [
                    {required: true}
                ],
                is_pay: [
                    {required: true}
                ]
            },
            date: null,
            start_at: null,
            end_at: null
        }
    },
    created() {
        this.host_id = this.$route.query.host_id || null
        this.app_id = this.$route.query.app_id || null
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        searchHost(keyword) {
            this.searchData.hostsLoading = true
            axios({
                url: 'admin/host/index',
                params: {
                    keyword: keyword,
                    status: 1
                }
            }).then(e => {
                this.searchData.hostsLoading = false
                if (e.data.code === 0) {
                    this.searchData.hosts = e.data.data.list
                } else {
                    this.searchData.hosts = []
                }
            }).catch(e => {
                this.searchData.hosts = []
            })
        },
        searchPlugins(keyword) {
            this.searchData.pluginsLoading = true
            axios({
                url: 'admin/app/index',
                params: {
                    keyword: keyword
                }
            }).then(e => {
                this.searchData.pluginsLoading = false
                if (e.data.code === 0) {
                    this.searchData.plugins = e.data.data.list
                } else {
                    this.searchData.plugins = []
                }
            }).catch(e => {
                this.searchData.plugins = []
            })
        },
        createSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    axios({
                        url: 'admin/app-order/create',
                        data: this.form,
                        method: 'post'
                    }).then(e => {
                        this.submitLoading = false
                        if (e.data.code === 0) {
                            this.$message.success(e.data.msg)
                            this.showCreateDialog = false
                            this.loadData(0)
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    }).catch(e => {
                    })
                } else {
                }
            })
        },
        loadData(page) {
            if (this.date) {
                this.start_at = this.date[0]
                this.end_at = this.date[1]
            } else {
                this.start_at = null
                this.end_at = null
            }
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/app-order/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        is_pay: this.is_pay,
                        host_id: this.host_id,
                        app_id: this.app_id,
                        start_at: this.start_at,
                        end_at: this.end_at
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        updateIsDelete(item, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认恢复订单？'
            } else {
                content = '是否确认删除订单？'
            }
            new Promise(resolve => {
                this.$confirm(content, '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = status
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/app-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.is_delete = status
                        this.$message.success(e.data.msg)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        updateIsPay(item, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认取消授权？'
            } else {
                content = '是否确认授权通过？'
            }
            this.$confirm(content, '提示', {}).then(() => {
                const data = helper.clone(item)
                data.is_pay = status
                data.pay_type = status === 1 ? 1 : 0
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/app-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.is_pay = status
                        this.$message.success('操作成功。')
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        },
        updatePayPrice(item) {
            let content = `订单原价: <span style="color: #999;text-decoration: line-through">${item.price}</span><br>`
            content += `支付金额: ${item.pay_price}<br>`
            content += `请输入订单需支付的金额:`
            this.$prompt(content, '修改价格', {
                dangerouslyUseHTMLString: true
            }).then(({value}) => {
                const data = helper.clone(item)
                data.pay_price = value
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/app-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.pay_price = value
                        this.$message.success('操作成功。')
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        },
        dateChange() {
            this.loadData(0)
        },
        searchApps(keyword) {
            axios({
                url: 'admin/app/index',
                params: {
                    keyword: keyword
                }
            }).then(e => {
                this.searchData.appLoading = false
                if (e.data.code === 0) {
                    this.searchData.apps = e.data.data.list
                } else {
                    this.searchData.apps = []
                }
            }).catch(e => {
                this.searchData.apps = []
            })
        }
    }
}
</script>

<style scoped>

</style>
